import { LogoutOutlined, RobotOutlined, MenuOutlined } from '@ant-design/icons';
import { Dropdown, MenuProps, Button } from 'antd';
import IconDown from 'assets/Icon/IconDown';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { removeAllCookies } from 'utils/cookies';
import LogoImage from 'assets/images/logo.png';
import { useAuth } from 'context/AuthContext';
import { useState } from 'react';

interface TCommonHeaderProps {
  isMobile?: boolean;
}

function TCommonHeader({ isMobile }: TCommonHeaderProps) {
  const { t } = useTranslation();
  const navi = useNavigate();
  const { user } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    removeAllCookies();
    localStorage.setItem('logout', Date.now().toString());
    navi('/login');
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <Link to="#" onClick={handleLogout}>
          {' '}
          <LogoutOutlined /> {t('menu.label.logout')}
        </Link>
      ),
      key: '0'
    }
  ];

  return (
    <div className={`h-full flex ${isMobile ? 'justify-between' : 'justify-end'} items-center`}>
      {isMobile && (
        <Button
          type="text"
          icon={<MenuOutlined style={{ color: '#fff', fontSize: '20px' }} />}
          onClick={() => window.dispatchEvent(new CustomEvent('toggle-mobile-sidebar'))}
          className="flex items-center justify-center p-0 h-10 w-10 hover:bg-[#ffffff20]"
        />
      )}
      <div className="flex gap-7 h-full items-center">
        <Button
          type="primary"
          icon={<RobotOutlined />}
          onClick={() => navi('/auto-register')}
          className="bg-[#1D6EBE] hover:bg-[#155494] border-none flex items-center gap-2 text-white font-medium shadow-sm transition-all"
          style={{ height: '36px', borderRadius: '6px', fontSize: '13px' }}
        >
          {isMobile ? 'Đăng ký nhanh' : 'Đăng ký nhanh (Alt + R)'}
        </Button>
        <Dropdown
          menu={{ items }}
          trigger={['click']}
          className="h-full cursor-pointer"
          open={dropdownOpen}
          onOpenChange={setDropdownOpen}
        >
          <div onClick={e => e.preventDefault()}>
            <div
              className="h-full flex items-center gap-3"
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setDropdownOpen(true);
                }
                if (e.key === 'Escape') {
                  setDropdownOpen(false);
                }
              }}
            >
              <img
                className="w-10 h-10 border-white border-[2px] rounded-full object-cover"
                src={user?.avatar || LogoImage}
                alt="avatar"
              />
              {!isMobile && (
                <>
                  <div className="flex flex-col gap-1 text-white">
                    <h3 className="text-sm font-medium">{user ? user.fullName : 'Undefined'}</h3>
                  </div>
                  <div className="pl-4">
                    <IconDown />
                  </div>
                </>
              )}
            </div>
          </div>
        </Dropdown>
      </div>
    </div>
  );
}

export default TCommonHeader;
